<template>
	<ModelForm
		:modelId="modelId"
		@fetch="$emit('update:unableEdit',!$hasPermission('city.edit'))"
		resource="destinations"
		:modelInfo="defaultModelInfo"
		v-slot="slotProps"
		:successCallback="successCallback"
	>
		<b-form-row>
			<b-form-group :disabled="unableEdit" class="col-4" label="Codigo">
				<b-form-input
					type="text"
					size="sm"
					v-model="slotProps.modelInfo.code"
					required
				/>
			</b-form-group>
			<b-form-group :disabled="unableEdit" class="col-4" label="Nombre">
				<b-form-input
					type="text"
					size="sm"
					v-model="slotProps.modelInfo.name"
					required
				/>
			</b-form-group>
			<b-form-group :disabled="unableEdit" class="col-4" label="Google Name">
				<b-form-input
					type="text"
					size="sm"
					v-model="slotProps.modelInfo.googleRefName"
				/>
			</b-form-group>
		</b-form-row>
		<b-form-row>
			<b-form-group :disabled="unableEdit" class="col-4" label="Estado">
				<b-form-input
					type="text"
					size="sm"
					v-model="slotProps.modelInfo.stateName"
					required
				/>
			</b-form-group>
			<b-form-group :disabled="unableEdit" class="col-4" label="País">
				<b-form-select
					size="sm"
					v-model="slotProps.modelInfo.countryId"
					:options="$root.auxVars.countriesOpts"
				/>
			</b-form-group>
			<b-form-group :disabled="unableEdit" class="col-4" label="Time zone">
				<b-form-select
					size="sm"
					v-model="slotProps.modelInfo.timeZoneId"
					:options="$root.auxVars.timeZonesOpts"
				/>
			</b-form-group>
		</b-form-row>
		<hr />
		<div class="text-right">
			<b-button :disabled="unableEdit" variant="primary" type="submit">{{
				modelId > 0 ? "Actualizar" : "Guardar"
			}}</b-button>
		</div>
	</ModelForm>
</template>

<script>
import ModelForm from "../../helpers/ModelForm.vue";

export default {
	props: {
		unableEdit: Boolean,
		modelId: {
			type: Number,
			required: false,
			default: -1
		},
		modalId: {
			type: String,
			required: true
		}
	},
	components: { ModelForm },
	data() {
		return {
			defaultModelInfo: {
				id: -1,
				code: "",
				name: "",
				stateName: "",
				googleRefName: "",
				countryId: 1,
				status: "active",
				timeZoneId: ""
			},
			statusOptions: [
				{ value: "active", text: "Activo" },
				{ value: "inactive", text: "Inactivo" }
			]
		};
	},
	computed: {},
	methods: {
		successCallback(event) {
			if (event.data?.id) this.$emit("modal-id", event.data.id);
			this.$root.auxVars.loadResourcesOpts({
				vm: this,
				resourceNames: ["destinationsOpts"],
				forceRefresh: true
			});
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["countriesOpts", "timeZonesOpts"]
		});
	}
};
</script>

<style></style>
